import { StorageKey } from './types';

/**
 * Token service to storage and retrive user tokens
 *  - access token
 *  - refresh token
 */
const TokenService = (function () {
  /**
   * Get key's value from storage
   * @param key the key to get from storage
   */
  const get = (key: string) => {
    return localStorage.getItem(key);
  };

  /**
   * Set a key value pair
   */
  const set = (key: string, value: string) => {
    localStorage.setItem(key, value);
  };

  const remove = (key: string) => {
    localStorage.removeItem(key);
  };

  /**
   * Get access token if any
   */
  const getToken = () => {
    return get(StorageKey.Token);
  };

  /**
   * Get refresh token if any
   */
  const getRefreshToken = () => {
    return get(StorageKey.RefreshToken);
  };

  /**
   * Get device id if any
   */
  const getDeviceId = () => {
    return get(StorageKey.DeviceId);
  };

  /**
   * Update tokens, for example when refresh token
   */
  const updateTokens = (
    token: string,
    refresh_token: string,
    device_id?: string
  ) => {
    set(StorageKey.Token, token);
    set(StorageKey.RefreshToken, refresh_token);
    device_id && set(StorageKey.DeviceId, device_id);
  };

  /**
   * Remove all tokens, for example when logging user out
   */
  const removeTokens = () => {
    for (const key of Object.values(StorageKey)) {
      remove(key);
    }
  };

  return {
    getToken,
    getRefreshToken,
    getDeviceId,
    updateTokens,
    removeTokens
  };
})();

export default TokenService;
